import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { CompanyReportsSearchData } from './types-store';
import { CodeSearchWire } from './types';

export const mapList = (listWire: CodeSearchWire[]): CompanyReportsSearchData[] => {

  if ((listWire?.length ?? 0) === 0) {
    return [];
  }

  return listWire.map(item => ({
    code: {
      value: item.code?.v,
      description: item.code?.d,
      disabled: parseAsDateUTC(item.code?.disabled)
    }
  }));
};
